import React from 'react';
import { SnackbarProvider, SnackbarProviderProps } from 'notistack';
import NotifyErrorIcon from '../Icons/NotifyIcons/NotifyErrorIcon';
import { useStyles } from './NotifyBar.styles';

const customIconVariant: SnackbarProviderProps['iconVariant'] = {
  error: <NotifyErrorIcon />,
};

const NotifyBar = (props: SnackbarProviderProps) => {
  const { classes } = useStyles();
  const snackbarClasses: SnackbarProviderProps['classes'] = {
    // variantError: classes.variantError,
    // variantSuccess: classes.variantSuccess,
  };
  const { maxSnack, children, action } = props;
  return (
    <SnackbarProvider
      maxSnack={maxSnack}
      action={action}
      iconVariant={customIconVariant}
      classes={snackbarClasses}
    >
      {children}
    </SnackbarProvider>
  );
};

export default NotifyBar;
